<template lang="pug">
component(
  :is="cardComponent"
  :post="post"
Component)
</template>
<script>
import PostCardMedia from './post-card--media'
import PostCardArticle from './post-card--article'

export default {
  name: 'post-card',
  components: {
    PostCardArticle,
    PostCardMedia,
  },
  props: {
    post: {
      type: Object,
    },
  },
  computed: {
    cardComponent() {
      switch (this.post.type) {
        case 'media':
          return PostCardMedia
        case 'article':
        default:
          return PostCardArticle
      }
    },
  },
}
</script>

<style lang="sass">
// variables
.post-card
  --post-card-accent-border-width: 5px

// post-card styles
.post-card
  position: relative
  cursor: pointer

  p 
    margin: 0
  p + p
    margin-top: 0.5rem

.post-card,
.post-card *
  box-sizing: border-box

.post-card__wrapper
  position: absolute
  overflow: hidden
  width: 100%
  height: 100%
  border: 1px solid var(--base-color)

.post-card__image
  width: 100%
  padding-bottom: calc(100% / 3)
  position: relative
  overflow: hidden
  border-bottom: var(--post-card-accent-border-width) solid var(--accent-color)
  background-position: center center

.post-card__content
  padding: 0.5rem
  font-size: 1.25rem

.post-card__subtitle
  display: inline-block
  margin-top: -0.5rem
  margin-bottom: 1rem

// modifiiers
.post-card.--hasImage
  .post-card__wrapper
    .post-card__content
      position: absolute
      top: calc((100% / 3))
      width: 100%
      height: calc((100% / 3) * 2)

// animations & transitions
.post-card
  box-shadow: 0 0 0 0 #2c3e5033
  transition: box-shadow 0.3s

.post-card__image
  background-size: 120%
  transition: background-size 0.3s

.post-card
  &:hover,
  &:focus,
  &.--focus
    box-shadow: 0 0.5rem 2rem 0 #2c3e5055
  
    .post-card__image
      background-size: 100%
</style>
